import ModelEntity from "../../model-entity"
import {EntityType} from "../../../gd/const/item"

export default class CustomEntityParams extends ModelEntity {

    public nameFieldLabel    : string    = 'name' // title field is mandatory and only label change is allowed for it

    constructor(data:any) {
        super('', EntityType.DYNAMIC_MODEL)

        this.nameFieldLabel = data?.nameFieldLabel || 'Name'
    }

    toJSON():JSONObject {
        return {
            nameFieldLabel  : this.nameFieldLabel
        }
    }

}
